import { useState } from "react";
import Button from "../components/Button";
import { ColorSelectorGroup } from "./ColorSelectorGroup";

const ConfirmModal = ({ colors, colorOptions, onConfirm, onCancel }) => {

    const [selectedColors, setSelectedColors] = useState(
        colorOptions.reduce((acc, co) => {
            acc[co.id] = co.defaultColor;
            return acc;
        }, {})
    );

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded p-6 space-y-4">
                <h3 className="text-lg font-semibold">Update Colors</h3>
                <p className="text-xs text-gray-600">Only the values you explicitly set will be updated</p>
                <ColorSelectorGroup colors={colors} items={colorOptions.map(co => ({ ...co, defaultColor: null, value: null }))} disabled={false} onChange={setSelectedColors} />
                <div className="flex justify-end gap-2 pt-5">
                    <Button label="Cancel" onClick={onCancel} variant="secondary" />
                    <Button label="Confirm" onClick={() => onConfirm(Object.fromEntries(
                        Object.entries(selectedColors).filter(([, value]) => value !== null)
                    ))} variant="primary" />
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;